//Returns user data to populate user reducer
import {useProductionURL} from "../helper/constants";

export const loginAPI = async (username, password) => {

    const resp = await fetch(`http${useProductionURL ? "s" : ""}://${window.location.hostname}${useProductionURL ? "/api" : ":5000"}/user/signin?` + new URLSearchParams({
        username: username,
        password: password,
    }))

    return await resp.json()
}

//Returns valid JWT on success or blank string on fail
export const isJWTValidAPI = async (jwt) => {

    if (jwt.includes(":")) {
        return ""
    }

    let resp;

    try {
        resp = await fetch(`http${useProductionURL ? "s" : ""}://${window.location.hostname}${useProductionURL ? "/api" : ":5000"}/user/verify_session`, {
            headers: {
                "auth": jwt
            }
        })
    } catch (error) {
        return ""
    }


    return resp.text()
}

//TODO: implement password reset API call
//Returns true if password reset email was sent
export const sendPasswordResetAPI = async (email) => {

    return true;
}

//Returns true if password was successfully changed
export const changePasswordAPI = async (jwt, oldPassword, newPassword) => {

    const resp = await fetch(`http${useProductionURL ? "s" : ""}://${window.location.hostname}${useProductionURL ? "/api" : ":5000"}/user/change_password?` + new URLSearchParams({
        oldpassword: oldPassword,
        newpassword: newPassword,
    }), {
        method: "PUT",
        headers: {
            "auth": jwt
        }
    })

    return await resp.json()
}

//Returns a list of all available dockets for a user
export const getAvailableDocketsAPI = async (jwt) => {
    const resp = await fetch(`http${useProductionURL ? "s" : ""}://${window.location.hostname}${useProductionURL ? "/api" : ":5000"}/user/get_available_dockets`, {
        headers: {
            "auth": jwt
        }
    })

    return resp.json()
}

export const getAvailableDocketsMetadataAPI = async (jwt) => {
    const resp = await fetch(`http${useProductionURL ? "s" : ""}://${window.location.hostname}${useProductionURL ? "/api" : ":5000"}/user/get_available_dockets/metadata`, {
        headers: {
            "auth": jwt
        }
    })

    return resp.json()
}
